import { render, staticRenderFns } from "./PersonAddressComponent.vue?vue&type=template&id=ea847394"
import script from "./PersonAddressComponent.vue?vue&type=script&lang=js"
export * from "./PersonAddressComponent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports